// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GoogleCircleFilledSvg from "@fishx/icons-svg/es/asn/GoogleCircleFilled";
import FishxIcon from '../components/FishxIcon';

var GoogleCircleFilled = function GoogleCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GoogleCircleFilledSvg
  }));
};

GoogleCircleFilled.displayName = 'GoogleCircleFilled';
export default React.forwardRef(GoogleCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GoogleCircleFilled.js
// module id = 2894
// module chunks = 0